import _isEmpty from 'lodash/isEmpty';
const getTaxesFeesObject = taxesFees => {
  let taxTotal = 0;
  let feeTotal = 0;
  if (taxesFees?.taxes) {
    taxesFees?.taxes.forEach(taxItem => {
      taxTotal += taxItem.amount;
    });
  }
  const refinedTaxesFees = {
    showTaxTotalOnly: true,
    totalTaxes: Math.floor(taxTotal),
    totalTaxesFees: taxesFees?.taxesAndFees ?? 0
  };
  if (taxesFees?.fees) {
    taxesFees?.fees.forEach(item => {
      refinedTaxesFees[item.name] = item.amount;
    });
    taxesFees?.fees.forEach(fee => {
      feeTotal += fee.amount;
    });
  }
  if (!taxesFees?.totalTaxesFees) {
    refinedTaxesFees.totalTaxesFees = Math.floor(feeTotal + taxTotal);
  }
  return refinedTaxesFees;
};
const buildTaxesFeesObject = (vehiclePaymentDetails, enableExternalPaymentFetch, offerValues) => {
  const {
    financeOfferValues,
    leaseOfferValues,
    cashOfferValues
  } = offerValues;
  // Ecommerce tenant
  if (!_isEmpty(vehiclePaymentDetails) && enableExternalPaymentFetch) {
    return {
      finance: financeOfferValues?.taxes || financeOfferValues?.fees ? getTaxesFeesObject(financeOfferValues) : {},
      lease: leaseOfferValues?.taxes || leaseOfferValues?.fees ? getTaxesFeesObject(leaseOfferValues) : {},
      cash: cashOfferValues?.taxes || cashOfferValues?.fees ? getTaxesFeesObject(cashOfferValues) : {}
    };
  }
  // Other tenants
  return {
    finance: financeOfferValues.taxesFees,
    lease: {
      capCost: leaseOfferValues.capCost,
      dueInAdvance: leaseOfferValues.dueInAdvance,
      ...leaseOfferValues.taxesFees
    },
    cash: cashOfferValues.taxesFees
  };
};
export { buildTaxesFeesObject as default };
